export const isAuthorizedactivity = (actId, authorizedActivities) =>
  authorizedActivities && authorizedActivities[actId] ? true : false;
